import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';
import ForeignTravelList from './ForeignTravelList';
import { ForeignTravel } from '../../../../policy/policyAPI';

import {
	ToggleSwitch,
	FormCheckConditional,
} from '../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
	onForeignTravelAdd: () => void;
	onForeignTravelBlur: (e: any) => void;
	onForeignTravelChange: (e: any, index: number) => void;
	onForeignTravelRemove: (index: number) => void;
}
const ForeignTravelQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		var valid = !(props.questionnaire.abroad == null);
		
		if (props.questionnaire.abroad === true) {
			if (props.questionnaire.foreignTravelList === undefined || props.questionnaire.foreignTravelList.length === 0) {
				valid = false;
			}
			else {
				valid = valid && props.questionnaire.foreignTravelList.reduce(
					(prev: boolean, curr: ForeignTravel) => {
						let validlocation = prev && (curr.abroadDuration !== null 
							&& curr.abroadDuration !== '' 
							&& curr.abroadLocation !== null 
							&& curr.abroadLocation !== '');

						if (curr.abroadLocation === 'Palestine' || curr.abroadLocation === 'Israel') {
							validlocation = validlocation && 
								(curr.abroadIsraelPalestine !== null && curr.abroadIsraelPalestine !== undefined);
						}
						return validlocation;
					}, 
					true);
			}
		}
		return !valid;
	};
	return (
		<div>
			<ToggleSwitch
				labelText={props.questions.abroad}
				name="abroad"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.abroad}
				className="toggle-yes-no"
				conditionalChildren={
					<FormCheckConditional isOpen={props.questionnaire.abroad} className="ml-0">
						<ForeignTravelList
							foreignTravelList={props.questionnaire.foreignTravelList}
							onForeignTravelAdd={props.onForeignTravelAdd}
							onForeignTravelBlur={props.onForeignTravelBlur}
							onForeignTravelChange={props.onForeignTravelChange}
							onForeignTravelRemove={props.onForeignTravelRemove}
						/>
					</FormCheckConditional>}
			/>		
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
		);
};

export default ForeignTravelQuestion;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/activitiesQuestions/ForeignTravelQuestion.tsx